var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { useMapLoader } from '../../hooks/useMapLoader';
// @ts-ignore не осилил косяк с тайпингами children
var Loader = function (props) {
    var children = props.children, params = __rest(props, ["children"]);
    var state = useMapLoader(params);
    if (children instanceof Function) {
        return children(state);
    }
    return !state.loading ? children : null;
};
export default memo(Loader);
